//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('choiceProdPriceGrps', {
//        templateUrl: 'views/components/views/choiceProdPriceGrps/choiceProdPriceGrps.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'choiceProdPriceGrpsService', function ($stateParams, stateService, choiceProdPriceGrpsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodId = $stateParams.prod_id;

//            vm.model = {
//                itemsListPriceGroups: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION

//            async function loadPriceGroups() {
//                vm.model.itemsListPriceGroups = await choiceProdPriceGrpsService.listPriceGroups({ prod_id: prodId });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION
            
//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'choiceprodpricegrp':
//                        go({
//                            choiceprodpricegrp_keyono: '0',
//                            prod_id_choice: prodId
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadPriceGroups();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
